// let getMediaEndPoint = "https://cms-stg.wmca.org.uk/umbraco/delivery/api/v2/media/item/";
// let getMediaEndPoint = "https://localhost:44353/umbraco/delivery/api/v1/media/item/";
let getMediaEndPoint = "https://cms.wmca.org.uk/umbraco/delivery/api/v2/media/item/";

const apiKey = process.env.REACT_APP_UMBRACO_API_KEY;

// Simple in-memory cache to avoid duplicate network requests for the same media id
const mediaCache = new Map();

const getUmbracoMedia = async (id) => {
  if (!id) return null;

  // Return cached promise/result if present
  if (mediaCache.has(id)) {
    return mediaCache.get(id);
  }

  const fetchPromise = (async () => {
    try {
      const response = await fetch(getMediaEndPoint + id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Api-Key": apiKey,
        },
      });

      if (!response.ok) {
        console.log("getUmbracoMedia error:", response.status, response.statusText);
        return null;
      }

      const data = await response.json();
      return data;
    } catch (err) {
      console.log("getUmbracoMedia fetch failed:", err);
      return null;
    }
  })();

  // Store the promise immediately so concurrent callers share it
  mediaCache.set(id, fetchPromise);
  return fetchPromise;
};

export default getUmbracoMedia;